// ThreeStepsSection.js
import React from 'react';

const ThreeStepsSection = () => {
  const steps = [
    {
      number: '1',
      title: 'CALL OUR OFFICE AT',
      subtitle: '(02) 6927 2706',
      description: 'Friendly staff members are waiting to take your call and answer your questions.'
    },
    {
      number: '2',
      title: 'SCHEDULE FREE',
      subtitle: 'IN-HOME ASSESSMENT',
      description: 'This will help us design your customised care plan with your specific needs in mind.'
    },
    {
      number: '3',
      title: 'ENJOY COMFORT &',
      subtitle: 'FREEDOM AT HOME',
      description: 'Enjoy the companionship of a certified caregiver & thrive in the comfort of home.'
    }
  ];

  return (
    <section className="py-16 px-6 md:px-12 lg:px-24" style={{ backgroundColor: '#AD2647' }}>
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white text-center mb-12 leading-tight">
          Three Steps to Senior Independence<br />
          and Peace of Mind for You
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-6">
          {steps.map((step, index) => (
            <div key={index} className="flex flex-col items-center text-center text-white">
              {/* Circle with Number */}
              <div className="relative w-24 h-24 mb-6">
                {/* Orange arc on right side */}
                <svg className="absolute inset-0 w-24 h-24 -rotate-90">
                  <circle
                    cx="48"
                    cy="48"
                    r="44"
                    stroke="#E85D2C"
                    strokeWidth="6"
                    fill="none"
                    strokeDasharray="138 276"
                    strokeLinecap="round"
                  />
                </svg>
                {/* White circle on left side */}
                <svg className="absolute inset-0 w-24 h-24 rotate-90">
                  <circle
                    cx="48"
                    cy="48"
                    r="44"
                    stroke="white"
                    strokeWidth="6"
                    fill="none"
                    strokeDasharray="138 276"
                    strokeLinecap="round"
                  />
                </svg>
                {/* Number in center */}
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="text-4xl font-bold text-white">{step.number}</span>
                </div>
              </div>
              
              {/* Content */}
              <div className="space-y-2">
                <h3 className="text-lg font-bold tracking-wide">
                  {step.title}
                </h3>
                <h4 className="text-lg font-bold tracking-wide">
                  {step.subtitle}
                </h4>
                <p className="text-sm font-light leading-relaxed max-w-xs mx-auto">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ThreeStepsSection;
